// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"fGDZTs","hidden":"iOl2Sm","splitTextWrapper":"nNtBg6","clampContainer":"ZrPd54","clamp":"_3D2li2"};